var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "462px",
    height: "462px",
    viewBox: "0 0 462 462",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F3BA2F",
    cx: 230.7,
    cy: 230.7,
    r: 230.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons_x2F_icon-24_x2F_networks_x2F_binance_x5F_smart_x5F_chain",
    transform: "translate(76.933333, 76.933333)",
    fill: "#131415"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.6,178.3 L248.4,213 L153.8,307.5 L59.3,213 L94.1,178.3 L153.8,238 L213.6,178.3 Z M153.8,118.5 L189.1,153.8 L189.1,153.8 L189.1,153.8 L153.8,189.1 L118.6,153.9 L118.6,153.8 L118.6,153.8 L124.8,147.6 L127.8,144.6 L153.8,118.5 Z M34.8,119 L69.6,153.8 L34.8,188.5 L-2.84217094e-14,153.7 L34.8,119 Z M272.8,119 L307.6,153.8 L272.8,188.5 L238,153.7 L272.8,119 Z M153.8,0 L248.3,94.5 L213.5,129.3 L153.8,69.5 L94.1,129.2 L59.3,94.5 L153.8,0 Z",
    id: "Combined-Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.44862b5cf087e21a4883794e3decd80e.svg";
export { ForwardRef as ReactComponent };